module.exports = __webpack_public_path__ + "img/cards.556e1594.png";